module.exports = __webpack_public_path__ + "media/images/ohap_new assignment_off-015be056261b3aae35caec5492af8870.png";